import { BSS_BREAKDOWN, SPARK_STAGES } from "@/data/mock";
import { TrendingUp, AlertCircle, CheckCircle2 } from "lucide-react";

export default function PortalDashboard() {
  const bss = 82;
  return (
    <div className="space-y-8">
      <div>
        <div className="eyebrow">// Welcome back</div>
        <h1 className="display-lg text-silver-50 mt-2">Harbor Dental</h1>
      </div>

      <div className="grid gap-6 lg:grid-cols-3">
        {/* BSS Gauge */}
        <div className="panel-hi p-8 lg:col-span-1">
          <div className="eyebrow">// Brand Strength Score</div>
          <div className="mt-4 flex items-baseline gap-3">
            <div className="font-display font-extrabold text-7xl text-brand-blue">{bss}</div>
            <div className="text-silver-300 font-mono text-xs">/ 100</div>
          </div>
          <div className="mt-3 chip"><CheckCircle2 size={10} /> Gate cleared · Phase 2 live</div>
          <div className="mt-6 space-y-3">
            {BSS_BREAKDOWN.map((b) => (
              <div key={b.category}>
                <div className="flex justify-between text-xs text-silver-200">
                  <span>{b.category}</span><span className="font-mono">{b.score}</span>
                </div>
                <div className="mt-1 h-1.5 rounded-full bg-ink-700 overflow-hidden">
                  <div className="h-full bg-brand-blue" style={{ width: `${b.score}%` }} />
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Live numbers */}
        <div className="grid gap-6 lg:col-span-2">
          <div className="grid grid-cols-2 gap-6">
            <Stat label="Leads (30d)" value="147" delta="+22%" up />
            <Stat label="Cost per lead" value="$38" delta="-18%" up />
            <Stat label="ROAS" value="8.4x" delta="+1.3" up />
            <Stat label="Review velocity" value="31 / mo" delta="+9" up />
          </div>
          <div className="panel p-6">
            <div className="eyebrow">// Spark Progress</div>
            <div className="mt-4 grid grid-cols-11 gap-1">
              {SPARK_STAGES.map((s) => (
                <div key={s.n} title={s.name} className={`h-10 rounded-sm ${s.n <= 7 ? "bg-brand-blue" : s.n === 8 ? "bg-brand-blue/40 animate-pulseGlow" : "bg-ink-700"}`} />
              ))}
            </div>
            <div className="mt-3 text-silver-300 text-sm font-mono">// Stage 8 — Sitemap & Wireframe in progress</div>
          </div>
        </div>
      </div>

      <div className="grid gap-6 md:grid-cols-2">
        <div className="panel p-6">
          <div className="flex items-center gap-2 text-brand-blue"><TrendingUp size={16} /><div className="eyebrow !text-brand-blue">// Next Upsell</div></div>
          <div className="display-md text-silver-50 mt-3">Content Engine (P2)</div>
          <p className="text-silver-300 text-sm mt-2">Projected CPL lift: -14% over 90 days based on current BSS trajectory.</p>
        </div>
        <div className="panel p-6">
          <div className="flex items-center gap-2 text-brand-red"><AlertCircle size={16} /><div className="eyebrow !text-brand-red">// Attention</div></div>
          <div className="display-md text-silver-50 mt-3">2 reviews need responses</div>
          <p className="text-silver-300 text-sm mt-2">Response SLA is 18h — currently at 26h for 2 open items.</p>
        </div>
      </div>
    </div>
  );
}

function Stat({ label, value, delta, up }: { label: string; value: string; delta: string; up?: boolean }) {
  return (
    <div className="panel p-6">
      <div className="eyebrow">// {label}</div>
      <div className="mt-3 font-display font-extrabold text-4xl text-silver-50">{value}</div>
      <div className={`mt-1 font-mono text-xs ${up ? "text-brand-blue" : "text-brand-red"}`}>{delta}</div>
    </div>
  );
}
